(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var bar = document.querySelector('.announcement');
    if (!bar) return;

    var setAnnouncementHeight = function (height) {
      document.documentElement.style.setProperty('--announcement-height', height + 'px');
    };

    var measure = function () {
      if (bar && getComputedStyle(bar).display !== 'none') {
        setAnnouncementHeight(bar.offsetHeight);
      } else {
        setAnnouncementHeight(0);
      }
    };

    window.addEventListener('resize', measure);
    window.addEventListener('load', measure);
    document.addEventListener('DOMContentLoaded', measure);
    measure();

    var root = document.querySelector('[data-announcement]');
    var closeBtn = bar.querySelector('[data-announcement-close]');

    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.style.display = 'none';
        setAnnouncementHeight(0);
        var stored = [];
        try {
          stored = JSON.parse(localStorage.getItem('announcement-closed') || '[]');
        } catch (e) {}
        var key = 'announcement-' + bar.id;
        if (stored.indexOf(key) === -1) {
          stored.push(key);
          try { localStorage.setItem('announcement-closed', JSON.stringify(stored)); } catch (e) {}
        }
      });
    }

    if (!root) return;

    var slides = Array.prototype.slice.call(root.querySelectorAll('.announcement__slide'));
    if (slides.length <= 1) return;

    var current = 0;

    var show = function (index) {
      slides.forEach(function (slide, i) {
        slide.hidden = i !== index;
      });
    };

    var autoplay = parseInt(root.dataset.autoplay || '5000', 10);

    show(0);
    setInterval(function () {
      current = (current + 1) % slides.length;
      show(current);
    }, autoplay);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var toggles = document.querySelectorAll('[data-sidebar]');
    var closes = document.querySelectorAll('[data-close-sidebar]');

    for (var i = 0; i < toggles.length; i++) {
      toggles[i].addEventListener('click', function () {
        document.body.classList.add('open-mobile-sidebar');
      });
    }
    for (var j = 0; j < closes.length; j++) {
      closes[j].addEventListener('click', function () {
        document.body.classList.remove('open-mobile-sidebar');
      });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  class CollectionFilters extends HTMLElement {
    connectedCallback() {
      this.filterToggle = this.querySelector('[data-filter-toggle]');
      this.filterPanel = this.querySelector('[data-filter-panel]');
      this.filterOverlay = this.querySelector('[data-filter-overlay]');
      this.filterClose = this.querySelector('[data-filter-close]');
      this.sortSelect = this.querySelector('[data-sort-select]');
      this.priceApply = this.querySelector('[data-price-apply]');
      this.filterInputs = this.querySelectorAll('[data-filter-value]');

      if (this.filterToggle) {
        this.filterToggle.addEventListener('click', () => this.toggleFilters());
      }
      if (this.filterClose) {
        this.filterClose.addEventListener('click', () => this.closeFilters());
      }
      if (this.filterOverlay) {
        this.filterOverlay.addEventListener('click', () => this.closeFilters());
      }
      if (this.sortSelect) {
        this.sortSelect.addEventListener('change', () => this.onSortChange());
      }
      if (this.priceApply) {
        this.priceApply.addEventListener('click', () => this.onPriceApply());
      }
      this.filterInputs.forEach((input) => {
        input.addEventListener('change', () => this.onFilterChange(input));
      });
    }

    toggleFilters() {
      const isOpen = this.filterPanel.classList.toggle('is-open');
      this.filterOverlay.classList.toggle('is-open', isOpen);
      this.filterToggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      document.body.style.overflow = isOpen ? 'hidden' : '';
    }

    closeFilters() {
      this.filterPanel.classList.remove('is-open');
      this.filterOverlay.classList.remove('is-open');
      this.filterToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    onSortChange() {
      const value = this.sortSelect.value;
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', value);
      window.location.href = url.toString();
    }

    onFilterChange(input) {
      window.location.href = input.dataset.filterUrl;
    }

    onPriceApply() {
      const minInput = this.querySelector('[data-price-min]');
      const maxInput = this.querySelector('[data-price-max]');
      const url = new URL(window.location.href);
      if (minInput && minInput.value) {
        url.searchParams.set(minInput.name, minInput.value);
      } else {
        url.searchParams.delete(minInput ? minInput.name : '');
      }
      if (maxInput && maxInput.value) {
        url.searchParams.set(maxInput.name, maxInput.value);
      } else {
        url.searchParams.delete(maxInput ? maxInput.name : '');
      }
      window.location.href = url.toString();
    }
  }
  customElements.define('collection-section', CollectionFilters);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["company-history"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var entries = document.querySelectorAll('[data-history-entry]');
    if (!entries.length) return;

    if (!('IntersectionObserver' in window)) {
      entries.forEach(function (entry) { entry.classList.add('is-visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (items) {
      items.forEach(function (item) {
        if (item.isIntersecting) {
          item.target.classList.add('is-visible');
          observer.unobserve(item.target);
        }
      });
    }, { threshold: 0.15 });

    entries.forEach(function (entry) { observer.observe(entry); });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["policies"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.policies').forEach(function (section) {
      var tabs = Array.prototype.slice.call(section.querySelectorAll('.policies__tab'));
      var panels = Array.prototype.slice.call(section.querySelectorAll('.policies__tab-panel'));
      if (!tabs.length) return;

      function activate(tab, focusTab) {
        tabs.forEach(function (t) {
          var isActive = t === tab;
          t.classList.toggle('policies__tab--active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
          t.setAttribute('tabindex', isActive ? '0' : '-1');
        });

        panels.forEach(function (panel) {
          var isActive = panel.id === tab.getAttribute('aria-controls');
          panel.classList.toggle('policies__tab-panel--active', isActive);
          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });

        if (focusTab) tab.focus();
      }

      tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
          activate(tab, false);
        });

        tab.addEventListener('keydown', function (e) {
          var nextIndex = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
            nextIndex = (index + 1) % tabs.length;
          } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
            nextIndex = (index - 1 + tabs.length) % tabs.length;
          } else if (e.key === 'Home') {
            nextIndex = 0;
          } else if (e.key === 'End') {
            nextIndex = tabs.length - 1;
          }

          if (nextIndex !== null) {
            e.preventDefault();
            activate(tabs[nextIndex], true);
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rich-text"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', (event) => {
    const toggle = event.target.closest('[data-rich-text-toggle]');
    if (!toggle) return;
    const content = toggle.closest('[data-rich-text-content]');
    if (!content) return;
    const more = content.querySelector('[data-rich-text-more]');
    if (!more) return;
    const isExpanded = more.hidden;
    more.hidden = !isExpanded;
    toggle.textContent = isExpanded ? toggle.dataset.less : toggle.dataset.more;
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["size-guide"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-size-guide-zoom-wrap]').forEach(function (wrap) {
      var img = wrap.querySelector('.size-guide__image');
      if (!img) return;

      var zoomOutBtn = wrap.querySelector('[data-size-guide-zoom-out]');
      var zoomInBtn = wrap.querySelector('[data-size-guide-zoom-in]');
      var resetBtn = wrap.querySelector('[data-size-guide-zoom-reset]');
      var zoomLevelEl = wrap.querySelector('[data-size-guide-zoom-level]');

      var MIN_SCALE = 1;
      var MAX_SCALE = 4;
      var ZOOM_STEP = 2.5;
      var ZOOM_INCREMENT = 0.5;
      var state = { scale: 1, x: 0, y: 0 };

      function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max);
      }

      function updateZoomUI() {
        if (zoomLevelEl) zoomLevelEl.textContent = Math.round(state.scale * 100) + '%';
        if (zoomOutBtn) zoomOutBtn.disabled = state.scale <= MIN_SCALE;
        if (zoomInBtn) zoomInBtn.disabled = state.scale >= MAX_SCALE;
        if (resetBtn) resetBtn.disabled = state.scale <= MIN_SCALE;
      }

      function applyTransform() {
        img.style.transform = 'translate(' + state.x + 'px, ' + state.y + 'px) scale(' + state.scale + ')';
        img.classList.toggle('is-zoomed', state.scale > 1);
        updateZoomUI();
      }

      function zoomTo(newScale, clientX, clientY) {
        var rect = img.getBoundingClientRect();
        var offsetX = clientX - rect.left - rect.width / 2;
        var offsetY = clientY - rect.top - rect.height / 2;
        state.scale = clamp(newScale, MIN_SCALE, MAX_SCALE);
        state.x = -offsetX * (state.scale - 1) / state.scale;
        state.y = -offsetY * (state.scale - 1) / state.scale;
        applyTransform();
      }

      function resetZoom() {
        zoomTo(MIN_SCALE, 0, 0);
      }

      function centerPoint() {
        var rect = img.getBoundingClientRect();
        return { x: rect.left + rect.width / 2, y: rect.top + rect.height / 2 };
      }

      img.addEventListener('click', function (e) {
        if (dragMoved) {
          dragMoved = false;
          return;
        }
        if (state.scale > 1) {
          resetZoom();
          return;
        }
        zoomTo(ZOOM_STEP, e.clientX, e.clientY);
      });

      if (zoomInBtn) {
        zoomInBtn.addEventListener('click', function () {
          var c = centerPoint();
          zoomTo(state.scale + ZOOM_INCREMENT, c.x, c.y);
        });
      }

      if (zoomOutBtn) {
        zoomOutBtn.addEventListener('click', function () {
          var c = centerPoint();
          zoomTo(state.scale - ZOOM_INCREMENT, c.x, c.y);
        });
      }

      if (resetBtn) {
        resetBtn.addEventListener('click', resetZoom);
      }

      wrap.addEventListener('keydown', function (e) {
        if (e.key === '+' || e.key === '=') {
          e.preventDefault();
          var c = centerPoint();
          zoomTo(state.scale + ZOOM_INCREMENT, c.x, c.y);
        } else if (e.key === '-' || e.key === '_') {
          e.preventDefault();
          var c2 = centerPoint();
          zoomTo(state.scale - ZOOM_INCREMENT, c2.x, c2.y);
        } else if (e.key === '0' || e.key === 'Escape') {
          e.preventDefault();
          resetZoom();
        }
      });

      wrap.addEventListener('wheel', function (e) {
        if (!(e.ctrlKey || e.metaKey)) return;
        e.preventDefault();
        var step = e.deltaY > 0 ? -ZOOM_INCREMENT / 2 : ZOOM_INCREMENT / 2;
        zoomTo(state.scale + step, e.clientX, e.clientY);
      }, { passive: false });

      updateZoomUI();

      var DRAG_THRESHOLD = 5;
      var dragging = false;
      var dragMoved = false;
      var startX = 0;
      var startY = 0;
      var lastX = 0;
      var lastY = 0;

      img.addEventListener('pointerdown', function (e) {
        if (state.scale <= 1) return;
        dragging = true;
        dragMoved = false;
        startX = e.clientX;
        startY = e.clientY;
        lastX = e.clientX;
        lastY = e.clientY;
        img.setPointerCapture(e.pointerId);
      });

      img.addEventListener('pointermove', function (e) {
        if (!dragging) return;
        state.x += (e.clientX - lastX);
        state.y += (e.clientY - lastY);
        lastX = e.clientX;
        lastY = e.clientY;
        if (!dragMoved) {
          var dx = e.clientX - startX;
          var dy = e.clientY - startY;
          if (Math.sqrt(dx * dx + dy * dy) > DRAG_THRESHOLD) dragMoved = true;
        }
        applyTransform();
      });

      ['pointerup', 'pointercancel'].forEach(function (evName) {
        img.addEventListener(evName, function () { dragging = false; });
      });

      var pinchStartDist = 0;
      var pinchStartScale = 1;

      function touchDist(touches) {
        var dx = touches[0].clientX - touches[1].clientX;
        var dy = touches[0].clientY - touches[1].clientY;
        return Math.sqrt(dx * dx + dy * dy);
      }

      wrap.addEventListener('touchstart', function (e) {
        if (e.touches.length !== 2) return;
        pinchStartDist = touchDist(e.touches);
        pinchStartScale = state.scale;
      }, { passive: true });

      wrap.addEventListener('touchmove', function (e) {
        if (e.touches.length !== 2 || !pinchStartDist) return;
        e.preventDefault();
        var dist = touchDist(e.touches);
        state.scale = clamp(pinchStartScale * (dist / pinchStartDist), MIN_SCALE, MAX_SCALE);
        applyTransform();
      }, { passive: false });

      wrap.addEventListener('touchend', function (e) {
        if (e.touches.length < 2) pinchStartDist = 0;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var isMobile = window.matchMedia('(max-width: 767px)').matches;

    document.querySelectorAll('.video-hero__video').forEach(function (video) {
      // With a separate mobile video, drop the one this device won't show
      // before it downloads anything (both are rendered with preload="none").
      var isDesktopOnly = video.classList.contains('video-hero__video--desktop');
      var isMobileOnly = video.classList.contains('video-hero__video--mobile');
      if ((isDesktopOnly && isMobile) || (isMobileOnly && !isMobile)) {
        video.remove();
        return;
      }

      if (reduceMotion) {
        video.removeAttribute('autoplay');
        video.pause();
        return;
      }

      if (isDesktopOnly || isMobileOnly) {
        video.muted = true;
        // autoplay lets the browser resume it if it paused an off-screen video.
        video.autoplay = true;
        var playing = video.play();
        if (playing && playing.catch) playing.catch(function () {});
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
